import React from 'react';
import VendorSignupForm from '../components/vendor/VendorSignupForm';

export default function VendorSignupPage() {
  return <VendorSignupForm />;
}
